<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
  </ng-container>
    
<ng-container *ngIf="modalForMultiplePayment">
   <mapfre-modal 
    [modalOptions]="paymentModal"
    (hideModalOutput)="resetHideModal()"
    (click)="resetHideModal()">
    <div class="modal-body no-margin-top margin-bottom mb8">
      <hr class="no-margin-bottom no-margin-top" />
      
      <div class="margin-top mt24 text-center">
        <div>
          <svg-information-icon-svg></svg-information-icon-svg>
        </div>
        <div class="info-consideration margin-top mt16">
          {{ 'For your consideration' }}
        </div>
       <div class="margin-top mt24 info-consideration-message">{{ 'An online payment has already been accepted for this policy today. Please confirm you want to make this additional payment' }}</div> 
      </div>
      <div class="text-center margin-bottom mb16 margin-top mt24">
        <mapfre-button
            (click)="sendPayment('Y')"
            [ngClass]="{ custom_loader: loader }"
            [disabledValue]="!loader"
            additionalClasses="basic primary medium-btn h40 w240 mx-auto margin-bottom mb24" 
          > {{ 'CONFIRM_PAYMENT' | translate }}
        </mapfre-button>
          <mapfre-button
            (click)="onClickBack()"
            additionalClasses="ghost secondary small-btn h32 no-padding mx-auto" 
          >{{ 'CANCEL' | translate }}
        </mapfre-button>
      </div>
    </div>
  </mapfre-modal>
</ng-container>

  <ng-container *ngFor="let policy of policyDetails">
    <ng-container *ngIf="policy?.policynumber.policyNumber === policyId && !loading">
      <mapfre-alert></mapfre-alert>
      <header class="margin-bottom mb16">
        <ng-container *ngIf="isAcmic; else MAStateBillingConfirmMK">
        <div class="type-title">
          <h1 class="title">
            {{ 'MAKE_A_CHECK_PAYMENT' | translate }}
          </h1>
          <div class="sub-title">{{ policy?.displayType?.label }} - <strong>{{ policy?.policynumber.policyNumber }}</strong></div>
        </div>
      </ng-container>
      <ng-template #MAStateBillingConfirmMK>
          <h2 class="title dm-sans-medium">
            {{ 'MAKE_A_CHECK_PAYMENT' | translate }}
          </h2>
          <div class="mt-4 sub-title brand-blue-secondary">            
          <ng-container *ngIf="policy?.policyType === 'HOME'; else nonHome">
            <img src="./assets/img/images/icon-home.svg" width="40" height="40" class="mr-2" alt="home icon" />
          </ng-container>
          <ng-template #nonHome>
            <ng-container *ngIf="policy?.policyType === 'UMBRELLA'; else carIcon">
              <img src="./assets/img/images/icon-umbrella.svg" width="40" height="40" class="mr-2" alt="umbrella icon" />
            </ng-container>
            <ng-template #carIcon>
              <img src="./assets/img/images/icon-car.svg" width="40" height="40" class="mr-2" alt="car icon" />
            </ng-template>            
          </ng-template>          
            {{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }}
          </div>
        </ng-template>
      </header>
      <section class="row policy-details-content no-margin-horizontal details-content" >
        <div class="col col1 no-padding-left">
        <ng-container *ngIf="isAcmic; else MAStateReviewPaymentMK">
          <h2 class="title new-payment">
            {{ 'REVIEW_PAYMENT' | translate }}
            <mapfre-button additionalClasses="edit-mk-btn link-button blue-link font-size xsmall-font text-capitalize float-right no-border no-padding no-margin waves-effect"
              *ngIf="achBilling; else routeForEdit" (click)="goBackToNewPayment()">
              <span>{{ 'EDIT' | translate }}</span>
              <img src="assets/img/images/icon-edit-acmic-24.svg"  alt="edit icon" />
            </mapfre-button>
            <ng-template #routeForEdit>
              <mapfre-button additionalClasses="edit-mk-btn link-button blue-link float-right no-border no-padding no-margin waves-effect"
                [routerLink]="['/billing/'+ policy?.policynumber.policyNumber +'/new-payment']">
                <span>{{ 'EDIT' | translate }}</span>
                <img src="assets/img/images/icon-edit-acmic-24.svg"  alt="edit icon" />
              </mapfre-button>
            </ng-template>
          </h2>
        </ng-container>
        <ng-template #MAStateReviewPaymentMK>
          <h2 class="title new-payment dm-sans-medium">
            {{ 'REVIEW_PAYMENT' | translate }}
            <mapfre-button additionalClasses="link-button red-link float-right no-border no-padding no-margin waves-effect"
              *ngIf="achBilling; else MAStaterouteForEdit" (click)="goBackToNewPayment()">
              <span>{{ 'EDIT' | translate }}</span>
              <img src="./assets/img/images/icon-edit-red.svg" width="24" height="24" alt="edit icon"/>
            </mapfre-button>
            <ng-template #MAStaterouteForEdit>
              <mapfre-button additionalClasses="link-button red-link float-right no-border no-padding no-margin waves-effect"
                [routerLink]="['/billing/'+ policy?.policynumber.policyNumber +'/new-payment']">
                <span>{{ 'EDIT' | translate }}</span>
                <img src="./assets/img/images/icon-edit-red.svg" width="24" height="24" alt="edit icon"/>
              </mapfre-button>
            </ng-template>
          </h2>
        </ng-template>
          <ng-container *ngIf="isAcmic; else maPaymentConfirmation">
            <div class="payment-confirmation">
              <div class="row margin-top mt24 margin-bottom mb16">
                <div class="col">
                    {{ 'PAYMENT_AMOUNT' | translate }}
                </div>
                <div class="col text-right">
                  <strong>{{billing?.paymentAmount | currency }}</strong>
                </div>
              </div>
              <div class="row margin-bottom mb16">
                <div class="col">
                    {{ 'BANK_ACCOUNT_NUMBER' | translate }}
                </div>
                <div class="col text-right">
                    <strong>{{billing?.bankAccount?.accountNumber.digits | maskAccountNumber}}</strong>
                </div>
              </div>
              <div class="row margin-bottom mb16">
                <div class="col">
                    {{ 'CHECK_NUMBER' | translate }}
                </div>
                <div class="col text-right">
                  <ng-container *ngIf="billing?.checkNumber === ''">
                      <strong>N/A</strong>
                  </ng-container>
                  <ng-container *ngIf="billing?.checkNumber !== '' ">
                      <strong>{{billing?.checkNumber}}</strong>
                  </ng-container>
                </div>
              </div>
              <div class="row margin-bottom mb16">
                <div class="col">
                  {{ 'ROUTING_NUMBER' | translate }}
                </div>
                <div class="col text-right">
                    <strong>{{billing?.bankAccount?.routingNumber.digits}}</strong>
                </div>
              </div>
              <div class="row margin-bottom mb16">
                <div class="col">
                    {{ 'HOLDER_NAME' | translate }}
                </div>
                <div class="col text-right">
                    <strong>{{billing?.bankAccount?.accountHolderName | titlecase}}</strong>
                </div>
              </div>
              <div class="row margin-bottom mb16" *ngIf="policyId.length !== 10">
                <div class="col">
                    {{ 'MAILING_ADDRESS' | translate }}
                </div>
                <div class="col text-right">
                    <strong>{{billing?.bankAccount?.mailingAddress?.streetName.replace('#',', APT ')}} {{ billing?.bankAccount?.mailingAddress.city }}, {{ billing?.bankAccount?.mailingAddress?.state }}, {{ billing?.bankAccount?.mailingAddress?.zipCode.code }}</strong>
                  </div>
              </div>
            </div>
          </ng-container>
          <ng-template #maPaymentConfirmation>
            <div class="payment-confirmation">
              <div class="row margin-top mt24">
                <div class="col">
                    {{ 'PAYMENT_AMOUNT' | translate }}
                </div>
                <div class="col mk-txt-left">
                  <strong>{{billing?.paymentAmount | currency }}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col">
                    {{ 'BANK_ACCOUNT_NUMBER' | translate }}
                </div>
                <div class="col mk-txt-left">
                    <strong>{{billing?.bankAccount?.accountNumber.digits | maskAccountNumber}}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col">
                    {{ 'CHECK_NUMBER' | translate }}
                </div>
                <div class="col mk-txt-left">
                  <ng-container *ngIf="billing?.checkNumber === ''">
                      <strong>N/A</strong>
                  </ng-container>
                  <ng-container *ngIf="billing?.checkNumber !== '' ">
                      <strong>{{billing?.checkNumber}}</strong>
                  </ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  {{ 'ROUTING_NUMBER' | translate }}
                </div>
                <div class="col mk-txt-left">
                    <strong>{{billing?.bankAccount?.routingNumber.digits}}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col">
                    {{ 'HOLDER_NAME' | translate }}
                </div>
                <div class="col mk-txt-left">
                    <strong>{{billing?.bankAccount?.accountHolderName | titlecase}}</strong>
                </div>
              </div>
              <div class="row" *ngIf="policyId.length !== 10">
                <div class="col">
                    {{ 'MAILING_ADDRESS' | translate }}
                </div>
                <div class="col mk-txt-left">
                    <strong>{{billing?.bankAccount?.mailingAddress?.streetName.replace('#',', APT ')}} {{ billing?.bankAccount?.mailingAddress.city }}, {{ billing?.bankAccount?.mailingAddress?.state }}, {{ billing?.bankAccount?.mailingAddress?.zipCode.code }}</strong>
                  </div>
              </div>
            </div>
          </ng-template>
          
          <div class="row text-center margin-top mt32">
            <div class="col">
              <mapfre-button
                [ngClass]="{'custom_loader':loader}"
                [disabledValue]="!loader" 
                additionalClasses="basic primary center-button waves-effect {{isAcmic ? 'large w-75': 'large-btn'}}"
                (click)='sendPayment("N")'>
                {{ 'CONFIRM_PAYMENT' | translate}}
              </mapfre-button>
            </div>
          </div>
          <div class="row text-center margin-bottom mb24 margin-top mt24">
            <div class="col">
              <mapfre-button *ngIf="achBilling; else nonGuestAchCancel"
                [disabledValue]="!loader"
                [inputType]="'submit'"
                [translateValue]="'CANCEL' | translate"
                additionalClasses="ghost secondary center-button waves-effect {{isAcmic ? 'large w-75': 'large-btn'}}"
                (click)="goBackToNewPayment()">
                {{ 'CANCEL' | translate }}
              </mapfre-button>
              <ng-template #nonGuestAchCancel>
              <mapfre-button
                [disabledValue]="!loader"
                [inputType]="'submit'"
                [translateValue]="'CANCEL' | translate"
                additionalClasses="ghost secondary center-button waves-effect {{isAcmic ? 'large w-75': 'large-btn'}}"
                [routerLink]="['/billing/'+ policy?.policynumber.policyNumber +'/new-payment']">
                {{ 'CANCEL' | translate }}
              </mapfre-button>
            </ng-template>
            </div>
          </div>
          <div class="row legal billing-confirm-legal margin-top mt24">
            <div class="col">
              <ng-container *ngIf="isAcmic; else MAstate">
                {{ 'PAYMENT_LEGAL_ONE_TIME' | translate }}
              </ng-container>
              <ng-template #MAstate>
                {{ 'PAYMENT_LEGAL' | translate }}
              </ng-template>
            </div>
          </div>
        </div>
        <div class="col col2" *ngIf="!achBilling">
          <app-billing-sidebar [policy]="policy"></app-billing-sidebar>
        </div>
      </section>
    </ng-container>
  </ng-container>
